import { Component, input, output, HostListener } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

/** # rs-overview-filters:
 *
 * Will add a default header with apply and clear buttons
 *
 * @example
 * <rs-overview-filters
 *   [canApply]="true"
 *   (onApply)="myApplyFunction()"
 *   (onClearFilters)="myClearFunction()"
 *   (onClose)="myCloseFunction()"
 * >
 *  [ADD YOUR CUSTOM FORM / CONTENT HERE]
 * </rs-overview-filters>
 *
 * */
@Component({
  selector: 'rs-overview-filters',
  templateUrl: 'rs-overview-filters.component.html',
  styleUrl: 'rs-overview-filters.component.scss',
  imports: [
    MatButton,
    MatIcon,
    MatIconButton,
    TranslateModule,
  ],
})
export class RsOverviewFiltersComponent {
  /** # @Input displayClose
   * Boolean value to indicate if the cross to close the filters should be displayed
   * */
  public readonly displayClose = input(false, { transform: coerceBooleanProperty });

  /** # @Input hideClearFiltersButton
   * Boolean value to indicate if the clear all button should be hidden
   */
  public readonly hideClearFiltersButton = input(false, { transform: coerceBooleanProperty });

  /** # @Input canApplyFilters
   * Boolean value to indicate if the filters can be applied or not
   * */
  public readonly canApply = input(true);

  /** # @Output onApply
   * Will emit event when apply button is clicked
   * */
  public readonly onApply = output();

  /** # @Output onClearFilters
   * Will emit event when clear filters button is clicked
   * */
  public readonly onClearFilters = output();

  /** # @Output onCloseFilters
   * Will emit an event when close filters button is clicked
   * */
  public readonly onClose = output();

  @HostListener('keydown', ['$event'])
  public handleKeyDown(event: KeyboardEvent): void {
    if (event.key !== 'Enter' || !this.canApply()) {
      return;
    }

    const isMac = navigator.userAgent.includes('Mac');
    const validCombination = isMac
      ? event.metaKey && !event.ctrlKey
      : event.ctrlKey;

    if (validCombination) {
      event.preventDefault();
      this.onApply.emit();
    }
  }
}
